
import API from './api'


const BASE_re_path = process.env.REACT_APP_re_path_PATH;

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return { 'Authorization': 'Token ' + token }
}


export const addCartDevices = (obj) => {
    return API.post(BASE_re_path + '/CartUserDevicesInfo/', obj, { headers: getHeaders() })
}
export const getCartDevices = (id) => {
    return API.get(BASE_re_path + `/CartUserDevicesInfo/?user=${id}` ,{ headers: getHeaders() })
}
export const getCartDevice = (id) => {
    return API.get(BASE_re_path + `/CartUserDeviceInfo/?deviceId=${id}` ,{ headers: getHeaders() })
}

export const removeCartDevices = (id) => {
    return API.delete(BASE_re_path + '/CartUserDeviceInfo/'+id+'/',{ headers: getHeaders() })
}
{/*export const removeCartDevice = (id) => {
    return API.delete(BASE_re_path + '/CartUserDevicesInfo/'+id+'/',{ headers: getHeaders() })
}*/}

export const EmptyCartDevices = (id) => {
    return API.delete(BASE_re_path + '/CartUserDevicesInfo/'+id+'/',{ headers: getHeaders() })
}